import LandingLayout from "../Layouts/LandingLayout";
import Images from "../Components/Images";
import { Heading, Box, Text, Image, Container, Grid } from "@chakra-ui/react";
import ReviewCard from "../Components/ReviewCard";
import TeamMember from "../Components/TeamMember";

function About() {
  return (
    <LandingLayout>
      <Box my="4rem">
        <Box
          position="absolute"
          left="50%"
          transform="translate(-50%, -50%)"
          my="4rem"
          textAlign="center"
        >
          <Heading size="xl">
            About{" "}
            <Text textDecoration="underline" d="inline" color="brand.900">
              PromiseCard
            </Text>{" "}
          </Heading>
          <Heading size="md">
            we offer a convenient way to get your wishlist fulfilled by friends
            and family
          </Heading>
        </Box>
        <Image
          pt={{ base: "100px", md: "0" }}
          marginX="auto"
          src={Images.People}
          alt="happy people"
        />
      </Box>
      <Box position="relative">
        <Image
          src={Images.Person6}
          alt="person"
          position="absolute"
          marginTop="2rem"
          left="0"
          display={{ base: "none", lg: "block" }}
          width="150px"
        />
        <Image
          src={Images.LeftHandSayingOk}
          alt="left hand saying ok"
          position="absolute"
          left="0"
          bottom="0"
          display={{ base: "none", lg: "block" }}
          width="250px"
        />
        <Image
          src={Images.RightHandPointingLeft}
          alt="right hand pointing left"
          position="absolute"
          top="0"
          right="0"
          display={{ base: "none", lg: "block" }}
          width="250px"
        />
        <Image
          src={Images.Person7}
          alt="person"
          position="absolute"
          marginBottom="2rem"
          bottom="0"
          right="0"
          display={{ base: "none", lg: "block" }}
          width="150px"
        />
        <Container mb="4rem" textAlign="center" maxW="container.md">
          <Heading size="xl">We’re in the business of wishes</Heading>
          <Text>
            Commodo enim est sint ut dolor do dolore proident sit ipsum fugiat.
            Cillum excepteur incididunt enim laborum. Nostrud in nisi id dolor
            aliquip Lorem duis occaecat fugiat Lorem laboris. Deserunt nisi do
            in nostrud irure ut. Adipisicing sint ut sint mollit nisi
            consectetur sunt officia qui eu et. Cupidatat elit cillum dolor
            nostrud fugiat nisi dolor excepteur. In culpa et quis duis enim
            aliquip sint proident deserunt consequat aliqua magna. Sunt dolor
            anim veniam amet est pariatur culpa ullamco do et nisi ea ut
            incididunt. Sint ipsum nulla et reprehenderit occaecat amet minim in
            mollit dolore. Et ut duis reprehenderit qui ipsum fugiat dolor elit
            excepteur exercitation est non culpa do. Proident qui occaecat sunt
            cupidatat enim pariatur dolore do ipsum voluptate officia
            consectetur eu velit. Enim officia culpa Lorem ipsum sint. Commodo
            laboris ut officia occaecat ipsum Lorem dolor consequat nisi do.
            Sunt reprehenderit pariatur cillum deserunt veniam nisi non anim.
            Consequat mollit sunt ex voluptate. Nulla aute nostrud proident sunt
            eiusmod laborum aliquip et eiusmod occaecat sit ex tempor. Dolore
            aute eiusmod nostrud magna velit nostrud non Lorem. Do deserunt do
            consequat ut proident nisi officia ullamco dolor. Adipisicing ut
            excepteur quis nostrud tempor quis id tempor consectetur duis
            exercitation deserunt ad amet. Est eiusmod excepteur nostrud amet
            minim.
          </Text>
        </Container>
      </Box>

      <Container mb="4rem" maxW="container.xl">
        <Box mb="2rem" textAlign="center">
          <Heading size="xl">Don’t just take our word for it</Heading>
          <Text size="lg">
            Find out what people are saying about thier experience using
            PromiseCard
          </Text>
        </Box>
        <Box overflowX="auto" whiteSpace="nowrap">
          <ReviewCard />
          <ReviewCard />
          <ReviewCard />
        </Box>
      </Container>

      <Container mb="4rem" maxW="container.xl">
        <Box mb="2rem" textAlign="center">
          <Heading size="xl">The Team</Heading>
          <Text size="2xl">
            We’re a diverse team of fairies on an adventure to fulfill wishes.
          </Text>
        </Box>
        <Box w="100%" margin="0 auto">
          <Grid
            gridTemplateColumns="repeat(auto-fit, minmax(250px, 1fr))"
            columnGap="1rem"
            rowGap="3rem"
            justifyContent="center"
          >
            {Array(8)
              .fill(0)
              .map((_, index) => {
                return <TeamMember key={index} />;
              })}
          </Grid>
        </Box>
      </Container>
    </LandingLayout>
  );
}

export default About;
